import PromotionBanner from './promotionBanner/PromotionBanner';
import ServiceShortcut from './serviceShortcut/ServiceShortcut';
import SpecialBanner from './specialBanner/SpecialBanner';
import HotIssue from './hotIssue/HotIssue';
import My from './my/My';
import Siege from './siege/Siege';
import { isDefined, isNotDefined, getFirstObjectHasProperty, namespace, parseInt10 } from './../utils/util';
import { BREAKPOINTS, API_DOMAIN_DEFAULT, STATIC_DOMAIN_DEFAULT } from './../model/model';

(function ($, global) {
  "use strict";

  let promotionBanner = null,
    serviceShortcut = null,
    specialBanner = null,
    hotIssue = null,
    mySection = null,
    siege = null;

  namespace('nc.lineage');

  nc.lineage.main = function (options) {
    if (isNotDefined(options)) throw new Error('nc.lineage.main require options object');

    let hotIssueData = null;
    if (global.popularKeyword && Array.isArray(global.popularKeyword.data)) {
      hotIssueData = getFirstObjectHasProperty(global.popularKeyword.data, 'pos', 'popkwd');
    }

    const option = $.extend(true, {
      apiDomain: API_DOMAIN_DEFAULT,
      staticDomain: STATIC_DOMAIN_DEFAULT,
      userData: null,

      promotionBanner: {
        wrap: null,
        rollingInterval: 5000,
        breakpoint: BREAKPOINTS,
        global: global
      },

      serviceShortcut: {
        wrap: null,
        breakpoint: BREAKPOINTS,
        global: global
      },

      specialBanner: {
        wrap: null,
        breakpoint: BREAKPOINTS,
        global: global
      },

      hotIssue: {
        wrap: null,
        data: hotIssueData,
        global: global
      },

      my: {
        wrap: null,
        global: global
      },

      siege: {
        wrap: null,
        serverId: 1,
        global: global
      }
    }, options);

    promotionBanner = new PromotionBanner(option.promotionBanner).init();

    serviceShortcut = new ServiceShortcut(option.serviceShortcut).init();

    specialBanner = new SpecialBanner(option.specialBanner).init();

    hotIssue = new HotIssue(option.hotIssue).init();

    mySection = new My({
      wrap: option.my.wrap,
      apiDomain: option.apiDomain,
      userData: option.userData,
      global: global
    }).init();

    siege = new Siege({
      wrap: option.siege.wrap,
      apiDomain: option.apiDomain,
      serverId: option.siege.serverId,
      global: global
    }).init();
  };

  /*
   * external methods
   */
  global.changeSiegeResult = function (serverId) {
    if (isDefined(siege)) siege.changeSiegeResult(parseInt10(serverId));
  };
}(jQuery, window));


// WEBPACK FOOTER //
// ./_src/js/main/main.js